export const getImage = (filename: string) => {
  return require(`../assets/images/${filename}`);
};
